import Util from "@/lib/util";
export default [
  {
    title: Util.L("Code"),
    width: 130,
    key: "code",
  },
  {
    title: Util.L("ExternalPOCode"),
    width: 130,
    key: "externalCode",
  },
  {
    title: Util.L("Status"),
    width: 100,
    key: "statusName",
  },
  {
    title: Util.L("Type"),
    width: 100,
    key: "poTypeName",
  },
  {
    title: Util.L("Customer"),
    width: 150,
    key: "customerName",
  },
  {
    title: Util.L("ConditionType"),
    width: 100,
    key: "conditionTypeName",
  },
  {
    title: Util.L("ContainerNumber"),
    width: 150,
    key: "containerNumber",
  },
  {
    title: Util.L("InvoiceNumber"),
    width: 150,
    key: "invoiceNumber",
  },
  {
    title: Util.L("CreationTime"),
    width: 150,
    key: "creationTime",
    render: (h: any, params: any) => {
      return h("span", Util.toViewDateString(params.row.creationTime));
    },
  },
];
